<template>
  <div class="fixed inset-x-0 bottom-0 z-50 bg-slate-900 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]">
    <div class="mx-auto flex max-w-7xl items-center justify-center px-4 py-3 sm:justify-between sm:px-6 lg:px-8">
      <div class="hidden items-center gap-3 sm:flex">
        <a
          href="https://rightmessage.com"
          class="flex-shrink-0"
        >
          <img
            src="/public/img/rmlogo.svg"
            alt="RightMessage"
            class="h-6 w-auto brightness-0 invert"
          >
        </a>
        <p class="text-sm font-medium text-white">
          Ready to start <span class="font-semibold text-orange-400">personalizing your marketing</span>?
        </p>
      </div>
      <div class="flex items-center gap-3">
        <a
          href="https://rightmessage.com/demo"
          class="rounded-md border border-slate-500 px-3.5 py-1.5 text-sm font-medium text-white transition hover:border-slate-400 hover:bg-slate-800"
        >
          Book a Demo
        </a>
        <a
          href="/register"
          class="rounded-md bg-orange-500 px-3.5 py-1.5 text-sm font-semibold text-white shadow-sm transition hover:bg-orange-400"
        >
          Start Free Trial
        </a>
      </div>
    </div>
  </div>
</template>
